import { render, staticRenderFns } from "./QuoteBlock.vue?vue&type=template&id=f24002b4&scoped=true"
import script from "./QuoteBlock.vue?vue&type=script&lang=js"
export * from "./QuoteBlock.vue?vue&type=script&lang=js"
import style0 from "./QuoteBlock.vue?vue&type=style&index=0&id=f24002b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24002b4",
  null
  
)

export default component.exports